<template>
  <v-card>
    <popup-form
      :title="newObj ? 'New Location' : 'Update Location'"
      :newObj="newObj"
      deleteItem="job"
      :buttonTitle="newObj ? 'Create' : 'Update'"
      :canDelete="canDelete"
      v-on:close="close"
      v-on:submit="submit"
      v-on:remove="remove"
    >
      <v-form ref="form" lazy-validation>
        <v-container>
          <v-row class="grey lighten-5 px-4 pt-4" no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="location.address"
                label="Location Address"
                filled
                outlined
                :rules="[rules.required]"
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="location.city"
                label="City"
                filled
                outlined
                :rules="[rules.required]"
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="location.postcode"
                label="Postcode"
                filled
                outlined
                :rules="[rules.required]"
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="location.name"
                label="Location Name"
                filled
                outlined
                :rules="[rules.required, rules.locationName]"
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="location.phone"
                label="Phone"
                filled
                outlined
                :rules="[rules.phone]"
                autocomplete="new"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="location.email"
                label="Email"
                filled
                outlined
                :rules="[rules.email]"
                autocomplete="new"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </popup-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rules from '@/rules.js';

export default {
  props: {
    location: Object,
    canDelete: Boolean
  },
  data() {
    return {
      rules: rules
    };
  },
  watch: {
    'location.postcode': function(value) {
      this.location.postcode = value.toUpperCase();
    }
  },
  computed: {
    newObj() {
      return !this.location._id;
    }
  },
  methods: {
    ...mapActions({
      createLocation: 'account/createLocation',
      updateLocation: 'account/updateLocation',
      deleteLocation: 'account/deleteLocation'
    }),
    submit() {
      if (this.$refs.form.validate()) {
        this.newObj ? this.create() : this.update();
      }
    },
    async create() {
      await this.createLocation(this.location);
      this.close();
    },
    async update() {
      await this.updateLocation(this.location);
      this.close();
    },

    async remove() {
      await this.deleteLocation(this.location._id);
      this.close();
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
